type WillyWonkaTitleIconProps = {
  url: string;
};

export const WillyWonkaTitleIcon = ({ url }: WillyWonkaTitleIconProps) => (
  <div className="willy-wonka-title">
    <img src={url} alt="theme-icon" fetchPriority="high" decoding="sync" />
  </div>
);
